import { ObjectValues } from "types";

const DeploymentQuotaTypes = {
  No: "",
  YesCustom: "CUSTOM",
  YesDaily: "DAILY",
  YesWeekly: "WEEKLY",
  YesMonthly: "MONTHLY",
} as const;

export type DeploymentQuotaType = ObjectValues<typeof DeploymentQuotaTypes>;

export default DeploymentQuotaTypes;
